<template lang="pug">
.fondoModal
	div
		div
			.card
				.card-header.bg-info.text-white
					|Selecciona imagen
					button.close(type="button" aria-label="Close" @click="cerrar")
						span(aria-hidden="true")|&times;
				.card-body(style="position:relative;display:block;")
					vue-cropper(@img="setImg($event)")
				.card-footer
					button.btn.btn-sm.btn-primary(@click="confirmar()" v-if="url")|Aceptar
</template>


<script>
export default {
	name: 'set-avatar',

	data: function () {
		return {
			url: null
		}
	},

	methods: {

		setImg (url) {
			this.url = url
		},

		confirmar () {
			this.$emit('img', this.url)
			this.cerrar()
		},

		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/gestion-usuarios/vue/editor/crop-avatar.vue